export const formatData = (data) => {
  const results = [];

  for (let i = 0; i < data.length; i++) {
    const { metricGroup, ...metric } = data[i];
    const found = results.find((el) => el.name === metricGroup.name);

    if (found) {
      found.children.push(metric);
    } else {
      const group = {
        name: metricGroup.name,
        id: metricGroup.id,
        children: [metric],
      };
      results.push(group);
    }
  }

  return results;
};
